<template>
  <div class="description-wrapper">
    <p class="description-text">
      Para os botões do Upsell funcionarem em sua página, você só precisa adicionar o
      <strong>{{ scriptText }}.</strong>
    </p>

    <a
      href="https://ajuda.herospark.com/hc/pt-br/articles/18329050821261-Como-configurar-o-Upsell-One-Click-"
      target="_blank"
      class="config-upsell-link"
    >
      <i class="fal fa-question-circle" />
      <span>
        Como configurar o Upsell?
      </span>
    </a>

    <button class="config-upsell-button" @click="$bvModal.show('code-modal')">Adicionar {{ scriptText }}</button>
  </div>
</template>

<script>
import WidgetSideNavMixin from './Mixin.js'

export default {
  name: 'UpsellSideNav',
  mixins: [WidgetSideNavMixin],
  data() {
    return {
      scriptText: '<script>',
      bracketsText: '</>',
    }
  },
}
</script>

<style lang="scss" scoped>
.description-wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 4px;
}
.description-text {
  font-size: 0.75rem;
  line-height: 1.125rem;
  color: #262626;
  margin: 0;
}

.config-upsell-link {
  font-size: 0.75rem;
  line-height: 1.125rem;
  color: #7427f1;
  display: flex;
  align-items: center;
  column-gap: 4px;

  span {
    text-decoration: underline;
  }
}

.config-upsell-button {
  background-color: #7427f1;
  color: #fff;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.313rem;
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  margin-top: 20px;

  &:hover {
    background-color: #4d1aa1;
  }
}
</style>
